import Plot from "react-plotly.js";

type HeatMapNewProps = {
  data: any;
  layout: any;
};

const HeatMapNew = (props: HeatMapNewProps) => {
    return (
      <Plot
        data={props.data}
        layout={props.layout}
        config={{ displayModeBar: false }}
      />
    );
  };
  
  export default HeatMapNew;